import { MedisanteDevice } from '../../../../pages/Device/types';

export interface Props {
  devices: MedisanteDevice[];
  isOpen?: boolean;
  onClose?(): void;
  onCreated?(): void;
}

export enum SelectedDevicesStatus {
  INITIAL = 'INITIAL',
  LINKED_SENSORS_SELECTED = 'LINKED_SENSORS_SELECTED',
  GATEWAY_SELECTED = 'GATEWAY_SELECTED',
  ALL_SET = 'ALL_SET',
}
